import { useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, Loader2, Trash2, FileText } from "lucide-react";
import { api, fileUrl } from "../../lib/api";
import { fmt, errMsg } from "./legalUtils";

export const FILE_CATS = ["مستند", "دليل / إثبات", "صور", "تقرير", "وثائق المخالف", "مراسلات", "حكم / قرار", "أخرى"];

export const LegalFiles = ({ c, onChanged }) => {
  const inp = useRef(null);
  const [cat, setCat] = useState(FILE_CATS[0]);
  const [busy, setBusy] = useState(false);
  const upload = async (files) => {
    setBusy(true);
    try {
      for (const file of files) {
        const r = await api.uploadFile(file);
        await api.legalAct(c.id, "attachments", { file_id: r.attachment_id, name: r.attachment_name || file.name, category: cat });
      }
      toast.success("تم رفع الملفات"); onChanged();
    } catch (e) { toast.error(errMsg(e, "فشل الرفع")); } finally { setBusy(false); }
  };
  const del = async (a) => { if (!window.confirm(`حذف «${a.name}»؟`)) return; await api.legalAttDelete(c.id, a.id).catch(() => {}); onChanged(); };
  const groups = (c.attachments || []).reduce((m, a) => ({ ...m, [a.category]: [...(m[a.category] || []), a] }), {});
  return (
    <div className="space-y-3">
      {c.can_act && (
        <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-dashed border-slate-300 p-3">
          <select value={cat} onChange={(e) => setCat(e.target.value)} className="h-9 rounded-md border px-2 text-sm" data-testid="legal-file-cat">{FILE_CATS.map((x) => <option key={x}>{x}</option>)}</select>
          <input ref={inp} type="file" multiple className="hidden" onChange={(e) => { upload([...e.target.files]); e.target.value = ""; }} data-testid="legal-file-input" />
          <button onClick={() => inp.current?.click()} disabled={busy} data-testid="legal-file-upload" className="flex h-9 items-center gap-1.5 rounded-md bg-[#0f1f3d] px-3 text-xs font-bold text-white">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Paperclip className="h-4 w-4" />} رفع مستندات وتصنيفها
          </button>
        </div>
      )}
      {Object.keys(groups).length === 0 && <p className="py-6 text-center text-sm text-slate-400">لا توجد مستندات</p>}
      {Object.entries(groups).map(([g, items]) => (
        <div key={g}>
          <p className="mb-1 text-xs font-extrabold text-slate-500">{g} ({items.length})</p>
          <div className="grid gap-2 sm:grid-cols-2">
            {items.map((a) => (
              <div key={a.id} className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2" data-testid={`legal-file-${a.id}`}>
                <FileText className="h-4 w-4 text-slate-400" />
                <a href={fileUrl(a.file_id)} target="_blank" rel="noreferrer" className="min-w-0 flex-1 truncate text-sm font-semibold text-blue-700 underline-offset-2 hover:underline">{a.name}</a>
                <span className="text-[10px] text-slate-400">{a.by} · {fmt(a.at)}</span>
                {c.can_act && <button onClick={() => del(a)} className="text-slate-300 hover:text-red-600"><Trash2 className="h-3.5 w-3.5" /></button>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
